import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';

import { arrayIsNotEmpty, cloneArray, formatDate, isDefined, sortReactTable } from '../../../utils';
import SortIcon from '../../../icons/v3/SortIcon';

class CoachedAgentsTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };
        this.getTableColumns = this.getTableColumns.bind(this);
    }

    getTableColumns() {
        const
            {
                calibratedOnSurveyQuestions,
            } = this.props;
        let nameHeader =
            (<div className="flex-container-center">
                <div>Agent</div>
                <div className="flex-container-center" style={{ marginLeft: '5px' }}><SortIcon /></div>
            </div>);

        let teamHeader =
            (<div className="flex-container-center">
                <div>Team</div>
                <div className="flex-container-center" style={{ marginLeft: '5px' }}><SortIcon /></div>
            </div>);

        const columns = [];
        columns.push(
            {
                Header: nameHeader,
                accessor: 'agentNameToShow',
                width: 160
            });
        columns.push(
            {
                Header: 'Session#',
                accessor: 'coachingSessionCount'
            });
        columns.push(
            {
                Header: teamHeader,
                accessor: 'agentTeam',
            });

        //if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
        //    calibratedOnSurveyQuestions.forEach(sq => {
        //        let questionHeader =
        //            (<div className="flex-container-center">
        //                <div>Pre-{sq.shortName}(%)</div>
        //                <div className="flex-container-center" style={{ marginLeft: '5px' }}><SortIcon /></div>
        //            </div>);
        //        columns.push(
        //            {
        //                Header: questionHeader,
        //                accessor: `${sq.internalName}BeforeCoaching`,
        //                //width: 100
        //            }
        //        );
        //    });
        //}

        columns.push(
            {
                Header: 'ReasonForContact',
                accessor: 'reasonForContact'
            });

        columns.push(
            {
                Header: 'Coach Date',
                accessor: 'coachingSessionDateFormatted'
            });

        if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
            calibratedOnSurveyQuestions.forEach(sq => {
                let questionHeaderPre =
                    (<div className="flex-container-center">
                        <div>Pre-{sq.shortName}(%)</div>
                        <div className="flex-container-center" style={{ marginLeft: '5px' }}><SortIcon /></div>
                    </div>);
                columns.push(
                    {
                        Header: questionHeaderPre,
                        accessor: `${sq.internalName}BeforeCoaching`,
                        //width: 100
                    }
                );
                let questionHeaderPost =
                    (<div className="flex-container-center">
                        <div>Post-{sq.shortName}(%)</div>
                        <div className="flex-container-center" style={{ marginLeft: '5px' }}><SortIcon /></div>
                    </div>);
                columns.push(
                    {
                        Header: questionHeaderPost,
                        accessor: `${sq.internalName}AfterCoachingToShow`,
                        //width: 100
                    }
                );
            });
        }

        columns.push(
            {
                Header: 'Pre-AHT (s)',
                accessor: 'ahtBeforeCoaching'
            });
        columns.push(
            {
                Header: 'Post-AHT (s)',
                accessor: 'ahtAfterCoachingToShow'
            });

        return columns;
    }

    render() {
        const
            {
                coachedAgentsData,
                calibratedOnSurveyQuestions,
                onClick
            } = this.props;

        let result = {};
        result.columns = this.getTableColumns();

        const loading = !coachedAgentsData;
        if (loading === true) {
            return (<ReactTable
                columns={result.columns}
                defaultPageSize={10}
                loading={loading}
                className="-striped -highlight"
            />);
        }

        const coachedAgentsDataCopy = cloneArray(coachedAgentsData);
        const numberOfAgentsLabel = coachedAgentsDataCopy ? `(${coachedAgentsDataCopy.length - 1} Agents)` : '';

        result.data = (coachedAgentsDataCopy && Array.isArray(coachedAgentsDataCopy))
            ? coachedAgentsDataCopy.filter(t => t.name !== "All Agents")
            : [];


        //form table body by adding icons and styling
        if (result.data && Array.isArray(result.data)) {
            result.data.forEach(row => {
                if (isDefined(row.agentName)) {
                    const firstLetter = row.agentName.charAt(0).toUpperCase();
                    row.agentNameToShow = <div style={{ textAlign: 'start' }}>
                        <div className="first-letter-avatar">
                            {firstLetter}
                        </div>
                        {row.agentName}
                    </div>;
                }

                if (arrayIsNotEmpty(row.sessionsDetail)) {
                    const agentFirstAudit = row.sessionsDetail[0];
                    row.reasonForContact = agentFirstAudit.reasonForContact;
                    row.ahtBeforeCoaching = agentFirstAudit.ahtBeforeCoaching;
                    if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
                        calibratedOnSurveyQuestions.forEach(sq => {
                            if (agentFirstAudit[`${sq.internalName}AfterCoaching`] != 0 && agentFirstAudit[`${sq.internalName}BeforeCoaching`] != 0) {
                                row[`${sq.internalName}BeforeCoaching`] = agentFirstAudit[`${sq.internalName}BeforeCoaching`];
                                const before = agentFirstAudit[`${sq.internalName}BeforeCoaching`];
                                const after = agentFirstAudit[`${sq.internalName}AfterCoaching`];
                                const delta = after - before;
                                let avatarStyle = delta > 0 ? "percentage-green-avatar" : "percentage-red-avatar";
                                row[`${sq.internalName}AfterCoachingToShow`] = (<div className={avatarStyle}>
                                    {agentFirstAudit[`${sq.internalName}AfterCoaching`]}
                                </div>);
                            }
                            if (agentFirstAudit[`${sq.internalName}BeforeCoaching`] == 0) {
                                agentFirstAudit[`${sq.internalName}BeforeCoaching`] = '-';
                                row[`${sq.internalName}AfterCoachingToShow`] = agentFirstAudit[`${sq.internalName}AfterCoaching`];
                            }
                            if (agentFirstAudit[`${sq.internalName}AfterCoaching`] == 0) {
                                row[`${sq.internalName}AfterCoachingToShow`] = '-';
                            }

                        });
                    }

                    if (agentFirstAudit.ahtAfterCoaching != 0 && agentFirstAudit.ahtBeforeCoaching != 0) {
                        let avatarStyle = agentFirstAudit.ahtBeforeCoaching > agentFirstAudit.ahtAfterCoaching ? "percentage-green-avatar" : "percentage-red-avatar";
                        row.ahtAfterCoachingToShow = (<div className={avatarStyle}>
                            {agentFirstAudit.ahtAfterCoaching}
                        </div>);
                    }
                    if (agentFirstAudit.ahtBeforeCoaching == 0) {
                        agentFirstAudit.ahtBeforeCoaching = '-';
                        row.ahtAfterCoachingToShow = agentFirstAudit.ahtAfterCoaching;
                    }
                    if (agentFirstAudit.avgQaScoreAfterCoaching == 0) {
                        row.ahtAfterCoachingToShow = '-';
                    }

                    if (isDefined(agentFirstAudit.coachingSessionDate)) {
                        row.coachingSessionDateFormatted = formatDate(agentFirstAudit.coachingSessionDate);
                    }
                }
            });
        }

        const teamsResultTable = (<ReactTable
            data={result.data}
            columns={result.columns}
            defaultPageSize={10}
            loading={loading}
            className="-striped -highlight"
            getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row && rowInfo.original) {
                    return {
                        onClick: () => {
                            onClick(rowInfo.original.teamId)
                        }
                    };
                } else {
                    return {};
                }
            }}
            defaultSortMethod={sortReactTable}
        />);

        return (<div>
            <div className="teams-table-for-manager filters-wrapper">
                <div className="teams-table-for-manager filter-area-title-wrapper">
                    <label className="teams-table-for-manager all-teams-title">All Agents</label>
                    <label className="teams-table-for-manager number-of-teams-title">{numberOfAgentsLabel}</label>
                </div>
            </div>

            <div style={{ position: 'relative', zIndex: 0 }}>
                {teamsResultTable}
            </div>

        </div>);
    };
}

const select = state => ({});
export default connect(select)(CoachedAgentsTable);

